import Vue from "vue";
import Router from "vue-router";
// 布局文件
import Layout from "./components/layout/mainLayout.vue";
import SecondLayout from "./components/layout/secondLayout.vue";
import UserCenterLayout from "./views/userCenter/UserCenterLayout.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/wechatLogin",
      name: "wechatLogin",
      component: () => import("./views/user/wechatLogin.vue")
    },
    {
      path: "/wechatAuth",
      name: "wechatAuth",
      component: () => import("./views/user/wechatAuth.vue")
    },
    {
      path: "/",
      name: "home",
      component: Layout,
      children: [
        {
          path: "spec",
          name: "spec",
          component: () => import("./views/home/spec.vue"),
          meta:{
            path: "/spec",
          }
        },
        // 专场招聘
        {
          path: "session",
          name: "session",
          component: () => import("./views/home/session.vue"),
          meta:{
            path: "/session",
          }
        },
        // {
        //   path: "",
        //   name: "index",
        //   component: () => import("./views/home/index.vue")
        // },
        // 主页
        {
          path: "",
          name: "index",
          component: () => import("./views/homePage/index.vue"),
          meta:{
            path: "/",
          }
        },
        // 职位
        {
          path: "job",
          name: "job",
          component: () => import("./views/job/index.vue"),
          meta:{
            path: "/job",
          }
        },
       
        {
            path: "company",
            name: "company",
            component: () => import("./views/company/index.vue"),
            meta:{
              path: "/company",
            }
          },
          {
            path: "about",
            name: "about",
            component: () => import("./views/aboutUs/index.vue"),
            meta:{
              path: "/about",
            }
          },

          {
            path: "myCollect",
            name: "myCollect",
            component: () => import("./views/userCenter/userCollect.vue"),
          },
       
          {
            path: "myInvite",
            name: "myInvite",
            component: () => import("./views/userCenter/userInvite.vue"),
          },
       
          {
            path: "myFeedback",
            name: "myFeedback",
            component: () => import("./views/userCenter/userFeedback.vue"),
          },
          {
            path: "myAccount",
            name: "myAccount",
            component: () => import("./views/userCenter/account.vue"),
          },
        // 小程序
        {
          path: "weapp",
          name: "weapp",
          component: () => import("./views/home/weapp.vue")
        },
        // 我的简历
        {
          path: "myresume",
          name: "myresume",
          component: () => import("./views/myresume/index.vue"),
          meta:{
            path: "/index",
          }
        },
        // 初始化简历
        {
          path: "resumeinit",
          name: "resumeInit",
          component: () => import("./views/myresume/resumeInit.vue"),
          meta:{
            path: "/index",
          }
        },
        {
          path: "resumeoptimize",
          name: "resumeoptimize",
          component: () => import("./views/myresume/completeresume.vue")
        },
        {
          path: "baseInfoAdd",
          name: "baseInfoAdd",
          component: () => import("./views/myresume/baseInfoAdd.vue")
        },
        {
          path: "register/protocol/introduce",
          name: "introduce",
          component: () => import("./views/user/introduce.vue")
        },
        {
          path: "index/privacy",
          name: "privacy",
          component: () => import("./views/user/userFiles/privacy-policy.vue")
        },
        {
          path: "index/jobPosting",
          name: "jobPosting",
          component: () => import("./views/user/userFiles/job-posting.vue")
        },{
          path: "index/userAgreement",
          name: "userAgreement",
          component: () => import("./views/user/userFiles/user-agreement.vue")
        },
        {
          path: "index/bussness",
          name: "bussness",
          component: () => import("./views/user/busseess.vue")
        },{
          path: "index/resource",
          name: "resource",
          component: () => import("./views/user/resources.vue")
        },
        {
          path: "myintro",
          name: "myintro",
          component: () => import("./views/myintro/index.vue"),
        },
      ]
    },
    {
      path: "/job",
      name: "job",
      component: Layout,
      redirect: "/job",
      children: [
        //全部职位
        {
          path: "list",
          name: "list",
          component: () => import("./views/job/allJob.vue")
        },
        // 职位详情
        {
          path: "/job/detail",
          name: "job",
          component: () => import("./views/job/detailNew.vue"),
          meta:{
            path: "/job",
          }
        }
      ]
    },
    {
      path: "/company",
      name: "companyDetail",
      component: Layout,
      redirect: "/company",
      children: [
        {
          path: "/company/detail",
          name: "company",
          component: () => import("./views/company/detail.vue"),
          meta:{
            path: "/company",
          }
        }
      ]
    },
    {
      path: "/",
      name: "second",
      component: SecondLayout,
      children: [
        {
          path: "login",
          name: "login",
          component: () => import("./views/user/login.vue")
        },
        {
          path: "register",
          name: "register",
          component: () => import("./views/user/register.vue")
        }
      ]
    },
    {
      path: "/message",
      name: "message",
      component: Layout,
      redirect: "/message/detail",
      children: [
        {
          path: "detail",
          name: "message-detail",
          component: () => import("./views/message/index.vue")
        }
      ]
    },
    {
      path: "/user-center",
      name: "userCenter",
      component: Layout,
      children: [
        {
          path: "",
          component: UserCenterLayout,
          children: [
            {
              path: "my-delivered-resume",
              name: "myDeliveredResume",
              component: () =>
                import("./views/userCenter/MyDeliveredResume.vue")
            },
            {
              path: "will-optimized-resume",
              name: "willOptimizedResume",
              component: () =>
                import("./views/userCenter/WillOptimizedResume.vue")
            },
            {
              path: "collection-resume",
              name: "collectionResume",
              component: () => import("./views/userCenter/CollectionResume.vue")
            },
            {
              path: "change-password",
              name: "changePassword",
              component: () => import("./views/userCenter/ChangePassword.vue")
            },
            {
              path: "binging-account",
              name: "bingingAccount",
              component: () => import("./views/userCenter/BingingAccount.vue")
            }
            // { path: '/', redirect: { name: '/home/index' }}
          ]
        }
      ]
    }
  ]
});
